const data = {
    lists: {
      "list-1": {
        id: "list-1",
        title: "To do",
        cards: [
          {
            id: "1",
            title: "vim practice",
          },
        ],
      },
      "list-2": {
        id: "list-2",
        title: "In Progress",
        cards: [],
      },
      "list-3": {
        id: "list-3",
        title: "Completed",
        cards: [],
      },
    },
    listIds: ["list-1", "list-2", "list-3"],
  };
  
  export default data;